import { useTranslation } from "react-i18next";
import SEOHead from "@/components/SEOHead";
import { OrganizationJsonLd, WebPageJsonLd, ProductJsonLd } from "@/components/JsonLd";
import Layout from "@/components/layout/Layout";
import HeroSection from "@/components/home/HeroSection";
// AtAGlanceSection removed from homepage flow (repetitive with Hero/Overview/Memberships).
// Component + atAGlance.* i18n keys retained for reuse on a future dedicated
// /thailand-privilege-card landing page.
import OverviewSection from "@/components/home/OverviewSection";
import AdvantagesSection from "@/components/home/AdvantagesSection";
import EligibilitySection from "@/components/home/EligibilitySection";
import MembershipSection from "@/components/home/MembershipSection";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import StepsSection from "@/components/home/StepsSection";
import HomeFaqSection from "@/components/home/HomeFaqSection";
import HomeGuidesSection from "@/components/home/HomeGuidesSection";
import CTASection from "@/components/home/CTASection";

// The whole membership catalogue, so the homepage advertises the full price
// range instead of only the Bronze entry price. Mirrors MEMBERSHIP_TIERS in
// public/_worker.js — keep the two in sync when pricing changes.
const MEMBERSHIP_TIERS = [
  { name: "Thailand Elite Bronze Membership — 5-Year Visa", price: 650000, url: "https://thailand-elite.com/membership/bronze" },
  { name: "Thailand Elite Gold Membership — 5-Year Visa", price: 900000, url: "https://thailand-elite.com/membership/gold" },
  { name: "Thailand Elite Platinum Membership — 10-Year Visa", price: 1500000, url: "https://thailand-elite.com/membership/platinum" },
  { name: "Thailand Elite Diamond Membership — 15-Year Visa", price: 2500000, url: "https://thailand-elite.com/membership/diamond" },
  { name: "Thailand Elite Reserve Membership — 20-Year Visa", price: 5000000, url: "https://thailand-elite.com/membership/reserve" },
];

const Index = () => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <SEOHead
        title={t("meta.homeTitle", "Thailand Elite – Long Stay Visas & Privileges | Official GSSA")}
        description={t("meta.homeDescription", "Thailand Elite (Thailand Privilege) official GSSA. 5 to 20 year multi-entry visa with VIP airport services, concierge, and exclusive privileges. Apply online today.")}
        lang={i18n.language}
        path="/"
      />
      {/* Organization identity — no aggregateRating (self-serving = ineligible per Google policy) */}
      <OrganizationJsonLd />
      {/* Homepage as Product so reviews/stars can appear in search snippets.
          offerTiers turns the single 650,000 THB Offer into an AggregateOffer
          across all five tiers — the page covers the whole catalogue, so
          quoting only the entry price undersold it for price queries. */}
      <ProductJsonLd
        name="Thailand Elite Visa Membership — Official GSSA"
        description="Official GSSA for Thailand Elite long-stay visa memberships. 5 to 20 year multi-entry visas with VIP airport services, concierge, and exclusive Thailand privileges."
        price="650000"
        currency="THB"
        image="https://thailand-elite.com/og-image.jpg"
        url="https://thailand-elite.com/"
        offerTiers={MEMBERSHIP_TIERS}
        withRatings={true}
      />
      {/* Tell Google which image to use for this page in image search / Discover */}
      <WebPageJsonLd
        url="https://thailand-elite.com"
        name="Thailand Elite Visa — Official GSSA | Long-Stay Visa Memberships"
        description="Become a Thailand Elite member. 5 to 20 year multi-entry visa, VIP services, airport fast-track, and exclusive privileges. Apply online today."
        primaryImage="https://thailand-elite.com/og-image.jpg"
      />
      <Layout>
        <HeroSection />
        <OverviewSection />
        <AdvantagesSection />
        <EligibilitySection />
        <MembershipSection />
        <TestimonialsSection />
        <StepsSection />
        <HomeFaqSection />
        <HomeGuidesSection />
        <CTASection />
      </Layout>
    </>
  );
};

export default Index;
